module.exports = __webpack_public_path__ + "img/table-sort-desc.31b5b8b9.svg";